import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Dash1, Dash2, Dash3, Dash4, Noimage } from "../../../common/imagePath";
import CountUp from "react-countup";
import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import LookupReceiptModal from "../../../components/Modal/LookupReceiptModal";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";

import moment from "moment";
import { Box, Button, MenuItem } from "@mui/material";
import { checkUserPermission } from "../../../common/UserPermission";
import MaterialReactTable from "material-react-table";
import DeleteIcon from "@mui/icons-material/Delete";

const Receiving = (props) => {
  let selectData = [];
  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");
  const [perPageSize, setperPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedReceivingCheckboxIds, setselectedReceivingCheckboxIds] =
    useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [recevingSummary, setRecevingSummary] = useState();
  const [rectype, setRectype] = useState([
    {
      ID: Number,
      SalesType: String,
    },
  ]);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [recoptions, setRecOptions] = useState([
    {
      Id: Number,
      CompanyName: String,
      FirstName: String,
      LastName: String,
      Email: String,
      PhoneNumber: Number,
      Address1: String,
      City: String,
      StateProvince: String,
      Zip: Number,
      Country: String,
    },
  ]);
  const [receivingTypeValue, setreceivingTypeValue] = useState();
  const [supplierValue, setsupplierValue] = useState();
  const [receivingTypeID, setReceivingTypeID] = useState(0);
  const [supplierID, setSupplierID] = useState(0);
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [showSearchBar, setShowSearchBar] = useState();
  const [status, setStatus] = useState(0);

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  let PERMISSION_DELETE = "receiving-batch-delete";
  let PERMISSION_EDIT = "/manage-receiving/:id";
  let PERMISSION_ADD = "/manage-receiving";
  let PERMISSION_RECEIPT = "/receiving-receipt/:id";
  let PERMISSION_PAYBILLS = "/receiving-paybills";
  let PERMISSION_TRANSFER = "/transfer-request/:id";
  let PERMISSION_INCOMING = "/incoming-transfer/:id";
  let PERMISSION_PURCHASE = "/create-purchase-orders";
  let PERMISSION_LASTRECEIVING = "/receiving-receipt";
  let PERMISSION_BATCHRECEIVING = "/batch-receiving";
  let PERMISSION_CUSTOMFIELD = "/receiving-custom-field";

  console.log(pagination, "pagination");
  // console.log("selectedReceivingCheckboxIds", selectedReceivingCheckboxIds);
  const handleReceipt = (pID) => {
    // axios
    //     .get(
    //         `${config.receivingBaseUrl}/receivings/listofsuspendrecordByid?id=${pID}`,
    //         {
    //             headers: {
    //                 "Content-Type": "application/json;charset=UTF-8",
    //                 "Access-Control-Allow-Origin": "*",
    //                 Authorization: token,
    //             },
    //         }
    //     )
    //     .then((res) => {
    //         console.log("res from Suspended Receiving", res);
    //     })
    //     .catch((err) => {
    //         console.log(err);
    //     });
  };

  //Styles
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  // const handleUnSuspend = (pID) => {
  //   // console.log("Pid",pID);
  //   axios
  //     .get(
  //       `${config.receivingBaseUrl}/receivings/listofsuspendrecordByid?id=${pID}`,

  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       // console.log("res from Suspended Receiving", res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     setSelectedRows(e.selectedRows.map((x) => x.ReceivingId));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.ReceivingId);
  //     console.log(e.selectedRows.map((x) => x.ReceivingId));

  //     const selectedReceivingCheckboxIds =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedReceivingCheckboxIds(selectedReceivingCheckboxIds);
  //     console.log(selectedReceivingCheckboxIds);
  //   }
  // };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate,
    receivingtypeid,
    supplierid,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    status
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    supplierid = supplierid > 0 ? supplierid : 0;
    receivingtypeid = receivingtypeid > 0 ? receivingtypeid : 0;
    startingdate = startingdate === undefined ? "" : startingdate;
    endingdate = endingdate === undefined ? "" : endingdate;

    axios
      .get(
        `${
          config.receivingBaseUrl
        }/receivings/listofalldata?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&startdate=${startingdate}&enddate=${endingdate}&receivingtypeid=${receivingtypeid}&supplierid=${supplierid}&status=${status}&LocationID=${localStorage.getItem(
          "Location"
        )}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("listofsuspendrecord", res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // if (quickBookOptions?.value !== 2) {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      receivingTypeID,
      supplierID,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      status
    );
    // }
  }, [
    receivingTypeID,
    supplierID,
    status,
    quickBookOptions,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
  ]);

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;

    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ReceivingId).join(",");
    } else {
      data = id;
    }

    const deleteRequestParam = {
      receivingids: data,
      loginuserid: loginuserid,
      locationid: location,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  // const contextActions = useMemo(() => {
  //     const handleDeletePopup = () => {
  //         const deleteRequestParam = {
  //             deliveriesids: selectedReceivingCheckboxIds,
  //         };
  //         localStorage.setItem(
  //             "DeleteRequestParam",
  //             JSON.stringify(deleteRequestParam)
  //         );
  //     };

  //     return (
  //         <button
  //             type="button"
  //             className="btn btn-success btn-sm pull-left "
  //             data-bs-toggle="modal"
  //             data-bs-target="#UnDeleteConfirmationModal"
  //             onClick={handleDeletePopup}
  //         >
  //             <i className="fa fa-trash fa-sm" /> Un Delete
  //         </button>
  //     );
  // }, [data, selectedRows, toggleCleared]);

  const contextActions = useMemo(() => {
    const handleDeletePopup = () => {
      const deleteRequestParam = {
        receivingids: selectedReceivingCheckboxIds,
        loginuserid: loginuserid,
        locationid: location,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  console.log(data, "table Data");

  // Table Data
  // const columns = [
  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <>
  //         <div class="btn-group-sm" role="group" >
  //           {row.ReceivingTypeId == 4 && row.Status == 2 ? "" : <>
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/manage-receiving/${row.ReceivingId}`}
  //               style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //             >
  //               Edit
  //             </Link>
  //           </>
  //           }
  //           <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           >
  //           </button>
  //           <div className="dropdown-menu">
  //             {/* {row.ReceivingTypeId == 4 && row.Status == 2 ? "" : <>
  //               <li>
  //                 <Link className="dropdown-item me-3" to={`/manage-receiving/${row.ReceivingId}`}>
  //                   <i className="fa fa-edit" title="Edit"></i>&nbsp;Edit Item
  //                 </Link>
  //               </li>
  //             </>} */}
  //             <li>
  //               <Link
  //                 className="dropdown-item confirm-text"
  //                 to="#"
  //                 title="Delete"
  //                 data-bs-toggle="modal"
  //                 data-bs-target="#DeleteConfirmationModal"
  //                 onClick={() => handleDeletePopup(row.ReceivingId)}
  //               >
  //                 <i
  //                   className="fa fa-trash"
  //                   data-bs-toggle="tooltip"
  //                   title="Delete"
  //                 ></i>&nbsp;Delete Receiving
  //               </Link>
  //             </li>
  //             <li>
  //               <Link
  //                 to={`/receiving-receipt/${row.ReceivingId}`}
  //                 className="dropdown-item me-3"
  //               >
  //                 <i className="fa fa-file" aria-hidden="true"></i>&nbsp;Receipt
  //               </Link>
  //             </li>
  //           </div>
  //         </div>
  //       </>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     // minWidth: "90px",
  //     // width: "90px",
  //   },
  //   // {
  //   //   name: "Sr No",
  //   //   selector: (row, index) => index + 1,
  //   //   width: "100px",
  //   // },
  //   {
  //     name: "Date",
  //     selector: (row) => row["Date"],
  //     sortable: true,
  //     width: "110px",
  //     minWidth: "110px",
  //   },
  //   {
  //     name: "Receive Type",
  //     selector: (row) => row["ReceiveType"],
  //     sortable: true,
  //     width: "130px",
  //     minWidth: "130px",
  //   },
  //   {
  //     name: "Status",
  //     selector: (row) => row["StatusName"],
  //     sortable: true,
  //     width: "110px",
  //     minWidth: "110px",
  //   },
  //   {
  //     name: "Supplier",
  //     // selector: (row) => row["Supplier"],
  //     sortable: true,
  //     // width: "120px",
  //     cell: (row) => (
  //       <Link class="text-warning word-break-data" to={`/manage-suppliers/${row.SupplierId}`}>
  //         {row.Supplier}
  //       </Link>
  //     ),
  //     width: "110px",
  //     minWidth: "110px",
  //   },
  //   // {
  //   //   name: "Items",
  //   //   selector: (row) => row["Items"],
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Total",
  //     selector: (row) => parseFloat(row["Total"]).toFixed(2),
  //     sortable: true,
  //     right: true,
  //     width: "110px",
  //     minWidth: "110px",
  //     // width:"120px"
  //   },
  //   {
  //     name: "Amount Paid",
  //     selector: (row) => row["AmountPaid"],
  //     sortable: true,
  //     right: true,
  //     width: "130px",
  //     minWidth: "130px"
  //     // width: "150px",
  //   },
  //   // {
  //   //   name: "Last Payment Date",
  //   //   selector: row => row["LastPaymentDate"],
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Credit Applied",
  //     selector: (row) => row["CreditApplied"],
  //     sortable: true,
  //     right: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Amount Due",
  //     selector: (row) => row["AmountDue"],
  //     sortable: true,
  //     right: true,
  //     width: "130px",
  //     minWidth: "130px"
  //     // width: "150px",
  //   },
  //   {
  //     name: "Comments",
  //     // selector: (row) => row["Comments"],
  //     selector: (row) => (
  //       <div className="word-break-data">
  //         {row.Comments}
  //       </div>
  //     ),
  //     // width: "130px",
  //     minWidth: "130px"
  //     // width: "200px",
  //   },

  //   {
  //     name: "Location",
  //     // selector: "Location",
  //     selector: (row) => row.Location,
  //     // width: "150px",
  //   },
  //   // {
  //   //   name: "Unsuspend",
  //   //   width: "150px",
  //   //   cell: (row) => {
  //   //     const handleClick = () => {
  //   //       handleUnSuspend(row.ID);
  //   //     };

  //   //     return (row.Status == 1 || row.Status == 2) &&
  //   //       (row.ReceivingTypeId == 1 || row.ReceivingTypeId == 2) ? (
  //   //       <Link to={`/manage-receiving/${row.ReceivingId}`}>
  //   //         <button
  //   //           onClick={handleClick}
  //   //           className={`btn btn-sm btn-outline-${
  //   //             row.Suspended === 1 ? "danger" : "success"
  //   //           }`}
  //   //         >
  //   //           {row.Suspended === 1 ? "Suspend" : "Unsuspend"}
  //   //         </button>
  //   //       </Link>
  //   //     ) : null;
  //   //   },
  //   // },
  //   // {
  //   //   name: "Receipt",
  //   //   width: "150px",
  //   //   cell: (row) => (
  //   //     <Link to={`/receiving-receipt/${row.ReceivingId}`}>
  //   //       <button
  //   //         onClick={handleReceipt(row.ReceivingId)}
  //   //         className="btn  btn-sm btn-outline-primary btn-custom-padding"
  //   //       >
  //   //         <i className="fa fa-file"></i> Receipt
  //   //       </button>
  //   //     </Link>
  //   //   ),
  //   // },
  //   // {
  //   //   name: "Action",
  //   //   width: "100px",
  //   //   cell: (row) => (
  //   //     <>
  //   //       {row.ReceivingTypeId == 4 && row.Status == 2 ? "" : <>
  //   //         <Link className="me-3" to={`/manage-receiving/${row.ReceivingId}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       </>}

  //   //       <Link
  //   //         className="confirm-text"
  //   //         to="#"
  //   //         title="Delete"
  //   //         data-bs-toggle="modal"
  //   //         data-bs-target="#DeleteConfirmationModal"
  //   //         onClick={() => handleDeletePopup(row.ReceivingId)}
  //   //       >
  //   //         <i
  //   //           className="fa fa-trash text-red fa-2x"
  //   //           data-bs-toggle="tooltip"
  //   //           title="Delete"
  //   //         ></i>
  //   //       </Link>
  //   //     </>
  //   //   ),
  //   // },
  // ];

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Receive Type",
      accessorKey: "ReceiveType",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Status",
      accessorKey: "StatusName",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Supplier",
      accessorKey: "Supplier",
      filterVariant: "multi-select",
      filterSelectOptions: recoptions.map(
        (option) =>
          option.CompanyName +
          " (" +
          option.FirstName +
          " " +
          option.LastName +
          ")"
      ),
      Cell: ({ row }) => (
        <Link
          class="text-warning word-break-data"
          to={`/manage-suppliers/${row.original.SupplierId}`}
          // component="span"
          // sx={(theme) => ({
          //   backgroundColor: theme.palette.warning.dark,
          //   borderRadius: '0.25rem',
          //   color: '#fff',
          //   maxWidth: '9ch',
          //   p: '0.25rem',
          //   cursor: "pointer"
          // })}

          // onClick={()=>navigate(`/manage-suppliers/${row.original.SupplierId}`)}
        >
          {row.original.Supplier}
        </Link>
      ),
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Total",
      accessorKey: "Total",
      cell: ({ row }) => parseFloat(row.original.Total).toFixed(2),
    },
    {
      header: "Amount Paid",
      accessorKey: "AmountPaid",
      cell: ({ row }) => parseFloat(row.original.AmountPaid).toFixed(2),
    },
    {
      header: "Credit Applied",
      accessorKey: "CreditApplied",
      cell: ({ row }) => row.original.CreditApplied,
    },
    {
      header: "Amount Due",
      accessorKey: "AmountDue",
      cell: ({ row }) => row.original.AmountDue,
    },
    {
      header: "Comments",
      accessorKey: "Comments",
      cell: ({ row }) => row.original.Comments,
    },
    {
      header: "Location",
      accessorKey: "Location",
      cell: ({ row }) => row.original.Location,
    },
  ]);

  const handleChangeStatus = (e) => {
    setStatus(e?.value);
  };

  //   if (hiddenColumns.includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }
  // // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  // const handlePerRowsChange = async (page, newPerPage) => {
  //   setperPageSize(newPerPage);
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     newPerPage,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeID,
  //     supplierID
  //   );
  // };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeID,
  //     supplierID
  //   );
  // };

  // const handleSort = (e, sortingDirection) => {
  //   setSortingId(e.id);
  //   setSortingDirection(sortingDirection);
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     e.id,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeID,
  //     supplierID
  //   );
  // };

  // fatch and display data on page load ===> ashish
  useEffect(() => {
    axios
      .get(`${config.receivingBaseUrl}/receivings/receivingtypedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("Receving Types", response.data.ResponseData);
        setRectype(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    // customer drop down
    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        setRecOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `${
          config.receivingBaseUrl
        }/receivings/receivingsummary?locationid=${localStorage.getItem(
          "Location"
        )}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("receiving summary", response.data.ResponseData[0]);
        setRecevingSummary(response.data.ResponseData[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const options = [
    { label: "All", value: 1 },
    { label: "Today", value: 7 },
    { label: "Last Day", value: 8 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };
  const supplierDropDown = recoptions.map((option) => ({
    value: option.ID,
    // label: option.FirstName + " " + option.LastName,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address,
  }));

  const handleQuickBookChange = (event) => {
    // event?.value !== 2 && handleSearchAccordingToDate();

    setQuickBookOptions(event);

    console.log(event, "quick book data");

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else if (event?.value == 7) {
      setStartingDate(moment().startOf("day").format("YYYY-MM-DD"));
      setEndingDate(moment().startOf("day").format("YYYY-MM-DD"));
    } else if (event?.value == 8) {
      const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
      setStartingDate(yesterday);
      setEndingDate(yesterday);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  // useEffect(() => {
  //   if (quickBookOptions?.value == 1) {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  //   // Custom Condition
  //   // else if (quickBookOptions?.value == 2) {
  //   //   setStartingDate(customStartingDate);
  //   //   setEndingDate(customEndingDate);
  //   // }
  //   // Last Week Condition
  //   else if (quickBookOptions?.value == 3) {
  //     const lastWeekStartDate = moment()
  //       .subtract(1, "week")
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const lastWeekEndDate = moment()
  //       .subtract(1, "week")
  //       .endOf("week")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastWeekStartDate);
  //     setEndingDate(lastWeekEndDate);
  //   }
  //   // Current Week Condition
  //   else if (quickBookOptions?.value == 4) {
  //     const currentWeekStartDate = moment()
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

  //     setStartingDate(currentWeekStartDate);
  //     setEndingDate(currentWeekEndDate);
  //   }
  //   // Last Month Condition
  //   else if (quickBookOptions?.value == 5) {
  //     const lastMonthStartDate = moment()
  //       .subtract(1, "month")
  //       .startOf("month")
  //       .format("YYYY-MM-DD");
  //     const lastMonthEndDate = moment()
  //       .subtract(1, "month")
  //       .endOf("month")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastMonthStartDate);
  //     setEndingDate(lastMonthEndDate);
  //   }
  //   //current Month
  //   else if (quickBookOptions?.value == 6) {
  //     const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
  //     const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

  //     setStartingDate(currentFirstDate);
  //     setEndingDate(currentLastDate);
  //   } else {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  // }, [quickBookOptions]);

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      receivingTypeID,
      supplierID,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      status
    );
  };

  const handleChangeReceivingType = (event) => {
    console.log(event?.value);
    setreceivingTypeValue(event);
    setReceivingTypeID(event?.value);
  };

  const handleChangeSupplier = (event) => {
    console.log(event);
    setsupplierValue(event);
    setSupplierID(event?.value);
  };

  let receivingTypeDropdownOption = [];
  const ReceivingTypeDropdown = rectype.map((u, i) => {
    receivingTypeDropdownOption[i] = { label: u.ReceivingsType, value: u.ID };
  });

  // const supplierDropDown = recoptions.map((option) => ({
  //   value: option.ID,
  //   // label: option.FirstName + " " + option.LastName,
  //   label:
  //     option.CompanyName +
  //     " (" +
  //     (option.FirstName + " " + option.LastName) +
  //     ")",
  //   address: option.Address,
  // }));

  const statusoption = [
    { label: "All", value: 0 },
    { label: "Completed", value: 2 },
    { label: "Paid", value: 4 },
    { label: "Pending", value: 1 },
    { label: "Rejected", value: 3 },
  ];

  // useEffect(() => {
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeID,
  //     supplierID
  //   );
  // }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Receiving</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                {/* <li className="breadcrumb-item">
                  <Link to="/receiving">Receiving List</Link>
                </li> */}
                <li className="breadcrumb-item active">Receiving List</li>
              </ul>
            </div>
          </div>
          <div
            // className="btn-group ms-2 dropdown"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            {checkUserPermission(PERMISSION_ADD) ? (
              <div className="me-2">
                <Link
                  // className="btn btn-added pull-right btn-sm"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  to={`/manage-receiving`}
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  New Receiving
                </Link>
              </div>
            ) : (
              ""
            )}
            {checkUserPermission(PERMISSION_PAYBILLS) ? (
              <div className="me-2">
                <Link
                  // className="btn btn-added pull-right  btn-sm"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  to={`/receiving-paybills`}
                >
                  {/* <i className="fa fa-plus me-2 lg"></i> */}
                  Pay Bills
                </Link>
              </div>
            ) : (
              ""
            )}
            <div className="btn-group btn-group-sm pull-right me-2">
              <button
                type="button"
                className="btn btn-outline-dark dropdown-toggle me-1  btn-sm"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ borderRadius: "5px" }}
              >
                More
              </button>

              <ul className="dropdown-menu">
                {/* <li>
                        <Link
                          to="/suspended-receiving"
                          title="Suspended receiving"
                          className="dropdown-item"
                        >
                          <i className="far fa-file fs-6 me-1"></i> Suspended
                          Receivings And Purchase orders
                        </Link>
                      </li> */}

                {checkUserPermission(PERMISSION_TRANSFER) ? (
                  <li>
                    <Link
                      to="/suspended-receiving/1"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Transfer Request
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_INCOMING) ? (
                  <li>
                    <Link
                      to="/suspended-receiving/0"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Incoming
                      Transfers
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_PURCHASE) ? (
                  <li>
                    <Link
                      to="/create-purchase-orders"
                      title="Create Purchase Order"
                      className="dropdown-item"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Create Purchase
                      Orders
                    </Link>
                  </li>
                ) : (
                  ""
                )}
                {checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                  <li>
                    <Link
                      // type="button"
                      className="dropdown-item"
                      data-bs-target="#LookupReceiptModal"
                      data-bs-toggle="modal"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Lookup Receipt
                    </Link>
                  </li>
                ) : (
                  ""
                )}
                {/* <LookupReceiptModal /> */}

                {checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                  <li>
                    <Link
                      to="/receiving-receipt"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Show Last
                      Receiving
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_BATCHRECEIVING) ? (
                  <li>
                    <Link
                      to="/batch-receiving"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      <i className="fas fa-shopping-bag fs-6 me-1"></i> Batch
                      Receiving
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_CUSTOMFIELD) ? (
                  <li>
                    <Link
                      to={"/receiving-custom-field"}
                      className="dropdown-item"
                    >
                      <i className="fas fa-wrench fs-6 me-1"></i> Custom Field
                      Configuration
                    </Link>{" "}
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </div>
            {/* <div className="btn-group btn-group-sm pull-right me-2">
              <button
                type="button"
                className="btn btn-outline-primary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ borderRadius: "5px" }}
              >
                <i className="fa fa-cog"></i> &nbsp;
              </button>
              <div className="dropdown-menu">
                {columns.map((column) =>
                  // omit Action column
                  column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                    <div
                      key={column.name.replace(/\s+|-|\/|#/g, "")}
                      className="form-check ms-2 mt-1"
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`checkbox-${column.name.replace(
                          /\s+|-|\/|#/g,
                          ""
                        )}`}
                        value={column.name.replace(/\s+|-|\/|#/g, "")}
                        checked={
                          !hiddenColumns.includes(
                            column.name.replace(/\s+|-|\/|#/g, "")
                          )
                        } // check all checkboxes which are not include in hiddenColumns
                        onChange={() =>
                          handleCheckboxChange(
                            column.name.replace(/\s+|-|\/|#/g, "")
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`checkbox-${column.name.replace(
                          /\s+|-|\/|#/g,
                          ""
                        )}`}
                      >
                        {column.name}
                      </label>
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            </div> */}
          </div>
          {/* summnery of recieving data */}
          <div className="row">
            <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget mb-0">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash1} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary?.PurchaseAmount} />
                      {/* <CountUp end={3000.80} /> */}
                    </span>
                  </h5>
                  <h6>
                    {recevingSummary?.PurchaseCount !== 0
                      ? recevingSummary?.PurchaseCount
                      : 0}{" "}
                    Purchase Orders
                  </h6>
                  {/* <h6>{3} Estimate</h6> */}
                </div>
              </div>
            </div>
            {/* <div className="col-lg-2 col-sm-4 col-12">
              <div className="dash-widget dash1">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash2} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary.UnbilledActivityAmount} />
                    </span>
                  </h5>
                  <h6>{recevingSummary.UnbilledActivityCount} Unbilled Activity </h6>
                </div>
              </div>
            </div> */}
            <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash2  mb-0">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash3} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary?.OverdueAmount} />
                    </span>
                  </h5>
                  <h6>
                    {recevingSummary?.OverdueCount !== 0
                      ? recevingSummary?.OverdueCount
                      : 0}{" "}
                    Overdue
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash3  mb-0">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash4} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary?.UnbilledActivityAmount} />
                    </span>
                  </h5>
                  <h6>
                    {recevingSummary?.UnbilledActivityCount !== 0
                      ? recevingSummary?.UnbilledActivityCount
                      : 0}{" "}
                    Open Bill
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash2 mb-0">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash2} alt="img" />
                    {/* <img src={Dash4} alt="img" /> */}
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary?.LastPaidCountAmount} />
                    </span>
                  </h5>
                  <h6>
                    {recevingSummary?.LastPaidCount !== 0
                      ? recevingSummary?.LastPaidCount
                      : 0}{" "}
                    Paid Last 30 Days
                  </h6>
                </div>
              </div>
            </div>
          </div>

          {/* filteration of table data */}
          <div className="row">
            <div className="d-flex flex-wrap mb-2">
              {/* <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                Search:
                <input
                  type="search"
                  placeholder="Search..."
                  className=" form-control form-control-sm"
                  onChange={ChangeFilterText}
                  value={searchtext}
                  width="1rem"
                />
              </div> */}
              <div className="pr-2 col-lg-2 col-md-5 col-sm-12">
                Date Filter:
                <Select
                  defaultValue={quickBookOptions}
                  onChange={(event) => {
                    handleQuickBookChange(event);
                  }}
                  options={options}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  // hideSelectedOptions={true}
                  styles={selectStyles}
                  className="custom-search-select"
                />
              </div>
              {quickBookOptions?.value == 2 && (
                <>
                  <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                    Custom Start Date:
                    <input
                      type="date"
                      className="form-control form-control-sm mt-1"
                      id="StartDate"
                      name="StartDate"
                      onChange={(event) =>
                        handleChangeCustomStartingDate(event)
                      }
                    />
                  </div>
                  <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                    Custom End Date:
                    <input
                      type="date"
                      className="form-control form-control-sm mt-1"
                      id="EndDate"
                      name="EndDate"
                      onChange={(event) => handleChangeCustomEndingDate(event)}
                    />
                  </div>
                  <div className="pr-2 col-lg-1 col-md-6 col-sm-12 mt-4">
                    <button
                      className="btn btn-dark btn-sm"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                </>
              )}

              {/* <div className="p-3 col-lg-1 col-md-6 col-sm-12 mt-4">
                  <button
                    className="btn btn-dark"
                    onClick={() => handleSearchAccordingToDate()}
                  >
                    {" "}
                    Search{" "}
                  </button>
                </div> */}
              <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                Receiving Type:
                <Select
                  defaultValue={receivingTypeValue}
                  onChange={(event) => {
                    handleChangeReceivingType(event);
                  }}
                  options={receivingTypeDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  styles={selectStyles}
                  className="custom-search-select"
                />
              </div>
              <div className="pr-2 col-lg-3 col-md-6 col-sm-12">
                Supplier:
                <Select
                  defaultValue={supplierValue}
                  onChange={(event) => {
                    handleChangeSupplier(event);
                  }}
                  options={supplierDropDown}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  styles={selectStyles}
                  className="custom-search-select"
                />
              </div>
              <div className="pr-2 col-lg-3 col-md-6 col-sm-12">
                Status:
                <Select
                  defaultValue={status}
                  onChange={(event) => {
                    handleChangeStatus(event);
                  }}
                  options={statusoption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  styles={selectStyles}
                  className="custom-search-select"
                />
              </div>
            </div>
            {/* <div className="col-lg-10 col-md-10 col-sm-12">
            </div> */}
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {/* <DataTable
                  title="Receiving List"
                  columns={filteredColumns}
                  data={data}
                  // progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  // contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  dense
                  paginationPerPage={perPageSize}
                /> */}
                <MaterialReactTable
                  columns={columns}
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  enableRowActions
                  renderRowActionMenuItems={({ row }) => [
                    checkUserPermission(PERMISSION_EDIT) ? (
                      row.original.ReceivingTypeId == 4 &&
                      row.original.Status == 2 ? (
                        ""
                      ) : (
                        <MenuItem
                          key="edit"
                          onClick={() =>
                            navigate(
                              `/manage-receiving/${row.original.ReceivingId}`
                            )
                          }
                        >
                          Edit
                        </MenuItem>
                      )
                    ) : (
                      ""
                    ),

                    checkUserPermission(PERMISSION_DELETE) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"

                        // title="Delete"
                        // data-bs-toggle="modal"
                        // data-bs-target="#DeleteConfirmationModal"
                        onClick={() =>
                          handleDeletePopup(row.original.ReceivingId, "", "")
                        }
                      >
                        Delete Receiving
                      </MenuItem>
                    ) : (
                      ""
                    ),

                    checkUserPermission(PERMISSION_RECEIPT) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"
                        onClick={() =>
                          navigate(
                            `/receiving-receipt/${row.original.ReceivingId}`
                          )
                        }
                      >
                        Receipt
                      </MenuItem>
                    ) : (
                      ""
                    ),
                  ]}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {console.log(table, "tables")}

                      {(table.getIsSomeRowsSelected() ||
                        table.getIsAllRowsSelected()) &&
                      checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                          size="small"
                          // disabled={
                          //   !table.getIsSomeRowsSelected() &&
                          //   !table.getIsAllRowsSelected()
                          // }
                          onClick={() =>
                            handleDeletePopup(
                              "",
                              table.getSelectedRowModel().rows,
                              "multipleRowInactive"
                            )
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          Delete
                        </Button>
                      ) : (
                        ""
                      )}

                      {/* <Button
                        size="small"
                        onClick={() =>
                          // setPagination({ ...pagination, pageSize: totalRows })
                          setPagination({
                            ...pagination,
                            pageIndex: 0,
                            pageSize: totalRows,
                          })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                  muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                  initialState={{
                    density: "compact",
                    // showGlobalFilter: true,

                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                  // muiTableContainerProps={{ sx: { maxHeight: 700 } }}

                  //For color of each alternative row
                  // muiTableBodyProps={{
                  //   sx: () => ({
                  //     '& tr:nth-of-type(odd)': {
                  //       backgroundColor: '#E5E5E5'
                  //     }
                  //   })
                  //   }}

                  muiTablePaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300],
                  }}
                  //For providing margin to each column
                  // muiTableBodyCellProps={{sx: {borderLeft: '1px solid #E0E0E0'}}}

                  //For providing color to header of table
                  // muiTableHeadCellProps={{
                  //   sx: theme => ({
                  //     background: 'rgba(52, 210, 235, 0.1)',
                  //     borderRight: '1px solid rgba(224,224,224,1)',
                  //     color: theme.palette.text.primary
                  //   })
                  // }}
                  manualFiltering // for termp comment filteron column
                  manualPagination
                  // positionGlobalFilter="left"
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    columnFilters, // for termp comment filteron column
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <LookupReceiptModal />
      <DeleteConfirmationModal
        deleteApiUrl={`${config.receivingBaseUrl}/receivings/batchdelete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default Receiving;
